import React from "react";

import { useState, useEffect, useRef } from 'react';
import { AudioRecorder, useAudioRecorder } from 'react-audio-voice-recorder';
import { IoMdClose } from 'react-icons/io';  

export default function Get_currentLocation() {
    const [selectedDate, setSelectedDate] = useState(new Date());

    // let selectedDate = ''
    // let setSelectedDate = ''
    return (
<>
</>
       

    );
}